import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";
import AuthShell from "../components/AuthShell";
import { useAuth, formatApiError } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const redirect = loc.state?.from || "/mon-espace";
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(form.email, form.password);
      toast.success("Connexion réussie !");
      nav(u.role === "admin" ? "/admin" : redirect, { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="[ Espace membre ]"
      title="Connexion."
      footer={<>Pas encore de compte ? <Link to="/inscription" className="text-ink font-semibold link-underline">Créer un compte</Link></>}
    >
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <div>
          <label className="label-mono text-ink/60 block mb-2">Email</label>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid="login-email" className="w-full bg-white border hairline rounded-sm px-4 py-3.5 outline-none focus:border-gold transition-colors" placeholder="vous@entreprise.fr" />
        </div>
        <div>
          <label className="label-mono text-ink/60 block mb-2">Mot de passe</label>
          <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            data-testid="login-password" className="w-full bg-white border hairline rounded-sm px-4 py-3.5 outline-none focus:border-gold transition-colors" placeholder="••••••••" />
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit"
          className="group w-full inline-flex items-center justify-center gap-2 rounded-full bg-ink text-paper px-6 py-4 label-mono hover:bg-gold hover:text-ink transition-colors disabled:opacity-60">
          {loading ? <><Loader2 size={16} className="animate-spin" /> Connexion...</> : <>Se connecter <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></>}
        </button>
      </form>
    </AuthShell>
  );
}
